import { ApiError, AuthError, NetworkError } from './api';

/**
 * D-423 — sunucu hatalarının tek yerelleştirme noktası.
 *
 * Sunucu hata gövdeleri düz **Türkçe** metinlerdir ve makine-okunur kod
 * taşımaz (`'Telefon numarası gerekli'`, `'Çok fazla kod isteği...'`).
 * Ekranlar bunları `e.message` ile ham gösterdiğinde Fransızca ya da Japonca
 * arayüzdeki kullanıcı Türkçe okuyordu. İstemcideki `NetworkError` ve
 * `AuthError` metinleri de aynı biçimde sabit Türkçedir.
 *
 * Burada yalnız **anlamı belirsiz olmayan** durumlar eşlenir; geri kalanı
 * çağıran ekranın kendi bağlamsal metnine düşer. Tahmin yürütülmez: bir
 * durumun ne anlama geldiği uç noktaya göre değişiyorsa burada değil, o
 * ekranda ele alınır (ör. `verify-otp`'de 401 "yanlış kod" demektir).
 */
export function errorMessageKey(error: unknown, fallbackKey: string): string {
  if (error instanceof NetworkError) return 'common.offline';
  if (error instanceof AuthError) return 'common.sessionExpired';
  if (error instanceof ApiError && error.status === 429) return 'common.tooManyRequests';
  return fallbackKey;
}
